/* eslint-disable internal-rules/no-restricted-design-system-props */
// eslint-disable-next-line internal-rules/no-restricted-design-system-imports
import { ThemeProvider } from '@change/ds-core-ui/next';

import { RoundShareIconButton } from 'src/app/shared/components/RoundShareIconButton';

import { useShareLinks } from './hooks/useShareLinks';

export function ShareLinks() {
	const {
		data: { buttonConfigs },
	} = useShareLinks();

	return (
		<ThemeProvider className="[&>div]:w-full">
			<div className="grid w-full grid-cols-[repeat(auto-fill,minmax(4.5rem,1fr))] items-center justify-items-center gap-x-2 gap-y-1 lg:gap-x-4">
				{buttonConfigs.map(({ channel, action, label, successLabel }) => (
					<RoundShareIconButton
						key={`update-share-${channel}`}
						action={action}
						channel={channel}
						label={label}
						successLabel={successLabel}
						data-qa={`update-share-${channel}`}
						data-testid={`update-share-${channel}`}
						className="w-[4.5rem]"
					/>
				))}
			</div>
		</ThemeProvider>
	);
}
